// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"58c14f54","235":"02ed7f0a","298":"8585311c","366":"7a489707","500":"12c04f21","639":"f2c4b3a4","787":"61f74e33","987":"06b66ff8"}[chunkId] + ".chunk.js";
};